"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DateRangePicker = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _styles = require("@material-ui/core/styles");
require("@proofpoint/react-dates/initialize");
require("@proofpoint/react-dates/lib/css/_datepicker.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
var _DayPickerRangeController = _interopRequireDefault(require("../DayPickerRangeController"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _colors = require("../../theme/colors");
var _excluded = ["align", "classes", "className", "dataMetrics", "initialStartDate", "initialEndDate", "isOutsideRange", "onApply", "onCancel"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var styles = function styles(theme) {
  return {
    actionContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px")
    },
    dateLabel: {
      height: 28
    },
    dateLabelDisabled: {
      color: _colors.opacity.black[38]
    },
    dateLabelHighlighted: {
      borderBottom: "2px solid ".concat(theme.palette.primary.main),
      color: theme.palette.primary.main,
      fontWeight: 500
    },
    labelContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      padding: theme.spacing(1, 2, 0)
    },
    labelContainerLeftAligned: {
      justifyContent: 'flex-start'
    },
    labelContainerRightAligned: {
      justifyContent: 'flex-end'
    },
    paper: {
      borderRadius: theme.shape.borderRadius / 2,
      width: 672
    },
    pickerContainer: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    separator: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5)
    }
  };
};
var defaultProps = {
  align: 'left',
  classes: {},
  dataMetrics: {
    root: 'fuse_date_range_picker'
  },
  onApply: function onApply() {},
  onCancel: function onCancel() {}
};

/**
 * This component is based on Airbnb's react-dates.
 *
 * The date range picker allows users to select a date range in an intuitive way. The implementation of this
 * component is based on `DayPickerRangeController`.
 *
 */
var _ref2 = /*#__PURE__*/_react["default"].createElement(_Divider["default"], null);
var DateRangePicker = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateRangePicker, _React$Component);
  var _super = _createSuper(DateRangePicker);
  function DateRangePicker(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, DateRangePicker);
    _this = _super.call(this, props);
    _this.state = {
      endDate: props.initialEndDate,
      focusedInput: 'startDate',
      hoverDate: null,
      startDate: props.initialStartDate
    };
    _this.handleApply = _this.handleApply.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDatesChange = _this.handleDatesChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocusChange = _this.handleFocusChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleHoverDateChange = _this.handleHoverDateChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(DateRangePicker, [{
    key: "getIntermediateDateInfo",
    value: function getIntermediateDateInfo() {
      var _this$state = this.state,
        endDate = _this$state.endDate,
        focusedInput = _this$state.focusedInput,
        hoverDate = _this$state.hoverDate,
        startDate = _this$state.startDate;

      // No date is hovered
      if (!hoverDate) {
        return {
          endDate: endDate || startDate,
          focusedInput: focusedInput,
          startDate: startDate
        };
      }

      // Picking a start date
      if (endDate) {
        return {
          endDate: endDate,
          focusedInput: focusedInput,
          startDate: hoverDate
        };
      }

      // Hovering on a date that is before the start date
      if (!startDate || hoverDate.isBefore(startDate)) {
        return {
          endDate: startDate,
          focusedInput: 'startDate',
          startDate: hoverDate
        };
      }

      // Hovering on a date that is after the start date
      return {
        endDate: hoverDate,
        focusedInput: focusedInput,
        startDate: startDate
      };
    }
  }, {
    key: "handleApply",
    value: function handleApply() {
      var onApply = this.props.onApply;
      var _this$state2 = this.state,
        endDate = _this$state2.endDate,
        startDate = _this$state2.startDate;
      onApply({
        endDate: endDate,
        startDate: startDate
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      var onCancel = this.props.onCancel;
      onCancel();
    }
  }, {
    key: "handleDatesChange",
    value: function handleDatesChange(_ref) {
      var startDate = _ref.startDate,
        endDate = _ref.endDate;
      this.setState({
        endDate: endDate,
        startDate: startDate
      });
    }
  }, {
    key: "handleFocusChange",
    value: function handleFocusChange(focusedInput) {
      this.setState({
        focusedInput: focusedInput
      });
    }
  }, {
    key: "handleHoverDateChange",
    value: function handleHoverDateChange(date) {
      this.setState({
        hoverDate: date
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _cx, _cx2, _cx3;
      var _this$props = this.props,
        align = _this$props.align,
        classes = _this$props.classes,
        className = _this$props.className,
        dataMetrics = _this$props.dataMetrics,
        initialStartDate = _this$props.initialStartDate,
        initialEndDate = _this$props.initialEndDate,
        isOutsideRange = _this$props.isOutsideRange,
        onApply = _this$props.onApply,
        onCancel = _this$props.onCancel,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var _this$state3 = this.state,
        endDate = _this$state3.endDate,
        focusedInput = _this$state3.focusedInput,
        startDate = _this$state3.startDate;
      var info = this.getIntermediateDateInfo();
      var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
      return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
        className: (0, _classnames["default"])(classes.paper, className),
        "data-metrics": mergedDataMetrics.root,
        elevation: 9
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.labelContainer, (_cx = {}, (0, _defineProperty2["default"])(_cx, classes.labelContainerLeftAligned, align === 'left'), (0, _defineProperty2["default"])(_cx, classes.labelContainerRightAligned, align === 'right'), _cx))
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: (0, _classnames["default"])(classes.dateLabel, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, classes.dateLabelDisabled, !info.startDate), (0, _defineProperty2["default"])(_cx2, classes.dateLabelHighlighted, info.focusedInput === 'startDate'), _cx2)),
        variant: "body1"
      }, info.startDate ? info.startDate.format('YYYY/MM/DD') : 'Start Date'), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: (0, _classnames["default"])(classes.dateLabel, classes.separator),
        variant: "body1"
      }, "-"), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: (0, _classnames["default"])(classes.dateLabel, (_cx3 = {}, (0, _defineProperty2["default"])(_cx3, classes.dateLabelDisabled, !info.endDate), (0, _defineProperty2["default"])(_cx3, classes.dateLabelHighlighted, info.focusedInput === 'endDate'), _cx3)),
        variant: "body1"
      }, info.endDate ? info.endDate.format('YYYY/MM/DD') : 'End Date')), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.pickerContainer
      }, /*#__PURE__*/_react["default"].createElement(_DayPickerRangeController["default"], (0, _extends2["default"])({
        endDate: endDate,
        focusedInput: focusedInput,
        isOutsideRange: isOutsideRange,
        onDatesChange: this.handleDatesChange,
        onFocusChange: this.handleFocusChange,
        onHoverDateChange: this.handleHoverDateChange,
        startDate: startDate
      }, rest))), _ref2, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.actionContainer
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "secondary",
        onClick: this.handleCancel,
        variant: "text"
      }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "secondary",
        disabled: !startDate || !endDate,
        onClick: this.handleApply,
        variant: "text"
      }, "Apply")));
    }
  }]);
  return DateRangePicker;
}(_react["default"].Component);
exports.DateRangePicker = DateRangePicker;
DateRangePicker.defaultProps = defaultProps;
DateRangePicker.displayName = 'DateRangePickerClass';
DateRangePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Set where the date range label should align.
   */
  align: _propTypes["default"].oneOf(['left', 'right']),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The initial end date of the date range.
   */
  initialEndDate: _propTypes["default"].object,
  /**
   * The initial start date of the date range.
   */
  initialStartDate: _propTypes["default"].object,
  /**
   * A predicate function that returns if the date is valid, which would allow
   * you to restrict which dates are selectable.
   *
   * @param {object} date the date to be evaluated if it is outside of the range
   */
  isOutsideRange: _propTypes["default"].func,
  /**
   * Callback fired when the apply button is clicked.
   *
   * @param {object} dateRange
   * { startDate: Moment Object, endDate: Moment Object }
   */
  onApply: _propTypes["default"].func,
  /**
   * Callback fired when the apply button is clicked.
   */
  onCancel: _propTypes["default"].func
} : {};
var ExportComponent = (0, _styles.withStyles)(styles)(DateRangePicker);
ExportComponent.displayName = 'DateRangePicker';
var _default = ExportComponent;
exports["default"] = _default;